import(/* webpackMode: "eager", webpackExports: ["LicensedStaticPage"] */ "/app/src/modules/license/components/LicensedStaticPage.tsx");
